import { IKnmSubject248ItAccreditationResponse } from 'APIPackage/KnmModule/interfaces/IKnmSubject248ItAccreditationResponse';
import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { itRegistryStatusTitles } from 'KnmPackage/MainModule/constants/itRegistryStatusTitles';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';

interface IKnmSubjectItAccreditationProps {
  itAccreditationResponse: IKnmSubject248ItAccreditationResponse;
}

export const KnmSubjectItAccreditation = ({ itAccreditationResponse }: IKnmSubjectItAccreditationProps) => {
  return (
    <>
      <Row>
        <FieldBlock label="Регистрационный номер в реестре аккредитованных IT-организаций" placementLabel="left">
          <TextInput
            className="shared-row-field"
            disabled
            value={itAccreditationResponse.registryNumber ? itAccreditationResponse.registryNumber : ''}
          />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Дата включения в реестр аккредитованных IT-организаций" placementLabel="left">
          <TextInput
            className="shared-row-field"
            disabled
            value={
              itAccreditationResponse.dateRecord
                ? formatDateLocale({
                    date: itAccreditationResponse.dateRecord,
                    dateFormat: DATE_FORMAT_LONG_FNS,
                  })
                : ''
            }
          />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock label="Статус организации в реестре аккредитованных IT-организаций" placementLabel="left">
          <TextInput
            className="shared-row-field"
            disabled
            value={
              itAccreditationResponse.organizationStatus
                ? itRegistryStatusTitles[itAccreditationResponse.organizationStatus]
                : ''
            }
          />
        </FieldBlock>
      </Row>
    </>
  );
};
